import { Link } from "react-router-dom";
import WorkCard from "@/components/feature/WorkCard";
import { worksList } from "@/mocks/works";

export default function WorkWall() {
  const items = worksList.slice(0, 8);
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="flex items-center gap-2">
            <i className="ri-star-smile-line text-xl text-accent-600" />
            <span className="text-sm font-medium text-accent-700">编辑精选</span>
          </div>
          <h2 className="mt-2 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            热门动漫作品精选
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            悬停海报即可查看简介，点击进入作品详情与观看指南。
          </p>
        </div>
        <Link
          to="/recommend"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-secondary-700"
        >
          浏览全部作品
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5" data-product-shop>
        {items.map((item) => (
          <WorkCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}